module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "navbar-container primary-green-bg",
    attrs: {
      "id": "navbar"
    }
  }, [_c('div', {
    class: {
      "navbar-head": true, "padding-transition": _vm.hideHead
    }
  }, [_c('div', {
    class: {
      "logo-banner": true, "hide": _vm.hideHead, "fade-in": !_vm.hideHead
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('userlogo', {
    class: {
      "hide": _vm.hideHead
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "dropdown-toggle primary-green-bg",
    on: {
      "click": _vm.toggleNavbar
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon fa-3x"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-separator"
  }, [_c('div', {
    staticClass: "mobile-nav"
  }, [_c('div', {
    class: {
      "dropdown": !_vm.navToggle
    }
  }, [_c('div', {
    staticClass: "email-container"
  }, [(_vm.merchant) ? _c('div', {
    staticClass: "email-text-style"
  }, [_vm._v("\n              " + _vm._s(_vm.merchant) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.email) ? _c('div', {
    staticClass: "email-text-style"
  }, [_vm._v("\n              " + _vm._s(_vm.email) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      "logo-banner-mini": true, "hide": !_vm.hideHead, "fade-in": _vm.hideHead
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "inline-block"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": {
        name: "PendingApproval"
      }
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.navToggle = !_vm.navToggle
      }
    }
  }, [_vm._v("Pending Approval")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": {
        name: "FileUpload"
      }
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.navToggle = !_vm.navToggle
      }
    }
  }, [_vm._v("File Upload")])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "inline-block right"
  }, [_c('router-link', {
    staticClass: "right",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "exact": true,
      "to": "/profile"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.navToggle = !_vm.navToggle
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', {
    staticClass: "primary-green-bg uppercase",
    on: {
      "click": _vm.logout
    }
  }, [_c('span', [_vm._v("Logout")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "scroll",
    style: ({
      "height": (_vm.scrollHeight + "px")
    }),
    on: {
      "resize": _vm.checkScrollAmount,
      "scroll": _vm.checkScrollAmount
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f8290c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Navbar.vue
// module id = 358
// module chunks = 2